<template>
  <div id="app">    
    <div v-if="isInitialized">
      <router-view />
    </div>
    <div 
      v-else-if="error_inicializacion" 
      class="error-load-container"
    >
      <div class="error-card">
        <div class="error-icon-bg">
          <svg 
            width="48" 
            height="48" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" 
              fill="#ef4444" 
            />
          </svg>
        </div>
        <h2>Error de Conexión</h2>
        <p>No pudimos conectar con el servidor. Por favor, verifica tu conexión a internet e inténtalo de nuevo.</p>
        <button 
          class="btn-retry" 
          :style="{ 'background': 'linear-gradient(135deg, ' + (prestador.admin ? prestador.admin.assets.colors.primary : '#3b82f6') + ', ' + (prestador.admin ? prestador.admin.assets.colors.secondary : '#2563eb') + ')' }"
          @click="reintentarCarga"
        >
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg" 
            style="margin-right: 8px;"
          >
            <path 
              d="M17.65 6.35C16.2 4.9 14.21 4 12 4C7.58 4 4.01 7.58 4.01 12C4.01 16.42 7.58 20 12 20C15.73 20 18.84 17.45 19.73 14H17.65C16.83 16.33 14.61 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C13.66 6 15.14 6.69 16.22 7.78L13 11H20V4L17.65 6.35Z" 
              fill="white" 
            />
          </svg>
          Reintentar Conexión
        </button>
      </div>
    </div>
    <div v-else>
      <img 
        :src="'https://assets-prestador-clinicgo.s3.sa-east-1.amazonaws.com/'+data_p.prestador_id+'/images/logo.png'" 
        style="max-height:80px; top: 50%; max-width: 200px; position: absolute; left:50%; transform: translate(-50%, -50%); " 
        alt="Imagen" 
      >
    </div>
    <notifications
      position="top right"
      group="foo"
    />
  </div>
</template>
<script>

import {mapActions, mapGetters} from 'vuex';
import axios from 'axios';
import '@/assets/estilo_importado/vendor/fonts/fontawesome.css';
import '@/assets/estilo_importado/vendor/fonts/tabler-icons.css';

export default {
    components:{},
    data(){
      return{
        data_p:{},
        cargando:false,
        subdominios:{
        'integramedica':{prestador_id: 9},
        //'neomedica':{prestador_id: 10},
        'cardiopro':{prestador_id: 11},
        'clini':{prestador_id: 4},
        'mediclic':{prestador_id: 1},
        'clinicaalemana':{prestador_id: 5},
        'regonesi':{prestador_id: 8},
        'reley':{prestador_id: 7},
        'laboratorioblanco':{prestador_id: 13},
        'ucchristus':{prestador_id: 14},
        //'':{prestador_id: 9},
        '':{prestador_id: 1},
        'davila':{prestador_id: 15},
        //'':{prestador_id: 11},
        'admin':{prestador_id: 1},
        'ucchristusencasa':{prestador_id: 16},
        'ucchristustest':{prestador_id: 21},
        'nomad':{prestador_id: 20},
        'sportsmd':{prestador_id: 18},
        'bionet': {prestador_id: 3},
        'clinicasantamaria':{prestador_id: 10},
      }
      }
    },
    methods: {
    ...mapActions(['getAdmin', 'initialize', 'logoutAdmin', 'getNotificaciones']),
    changeFavicon(url) {
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = url;
      document.getElementsByTagName('head')[0].appendChild(link);
    },
    reintentarCarga() {
      // Reiniciamos el proceso de carga con la misma data original
      const data_init = { ...this.data_p };
      if (!localStorage.token_admin) {
        data_init.scope = 'login';
      }
      this.initialize(data_init);
    }
    },
    computed: {
    ...mapGetters(['admin_datos', 'isLoggedIn', 'regiones', 'comunas', 'prestador', 'error_inicializacion']),
    isInitialized(){
      if (this.prestador && this.prestador.id)
        return true;
      return false;
    }
    },
    created(){
      document.title = 'Cargando...';
      var hostname_ = window.location.hostname;  
      // ! DEBUG
      //var hostname_ = 'admin.ucchristusencasa.clinicgo.cl';

      //var href_ = window.location.href
      hostname_ = hostname_.replace('https://', '')
      var subdomain1 = hostname_.split('.').length > 2 ? hostname_.split('.')[0] : '';
      var subdomain2 = hostname_.split('.').length > 2 ? hostname_.split('.')[1] : '';
      var data_;

      if(subdomain2 in this.subdominios){
        data_ = this.subdominios[subdomain2]
      }
      else if(subdomain1 in this.subdominios){
        data_ = this.subdominios[subdomain1]
      }
      this.data_p = data_;
      
      // Si no hay token, solo cargamos lo necesario para el login (ultra-rápido)
      const data_init = { ...data_ };
      if (!localStorage.token_admin) {
        data_init.scope = 'login';
      }
      
      this.initialize(data_init);

    },
    mounted() {
      this.changeFavicon('https://assets-prestador-clinicgo.s3.sa-east-1.amazonaws.com/'+this.data_p.prestador_id+'/images/favicon.ico')
      this.ENV = process.env;
    },
    watch:{
    prestador(val){

      document.title = this.prestador.nombre+ ' - Administración';
      if(this.admin_datos.length == 0 && typeof(localStorage.token_admin) != "undefined")
      {
        
        this.cargando = true;
        axios.defaults.headers.common['Authorization'] = localStorage.token_admin
        this.getAdmin({prestador_id:this.prestador.id})
        .then(e=>{
          this.getNotificaciones();
          this.cargando = false; this.$router.push('/Inicio') 
        }).catch(e=>{this.cargando = false;});
        
      }
    },
  },
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


#nav {
  padding: 30px;
}
.icon-edit{
  cursor: pointer;
}
.btn-ir{
  border: none;
  border-radius: 4px;
  padding: 2px 20px;
  color:#fff;
  cursor: pointer;
}
.btn-ir:hover{
  opacity: 0.8;
}
.btn-ir-gordo{
  border: none;
  border-radius: 4px;
  padding: 8px 20px;
  color:#fff;
  transition: 0.3s;
  cursor: pointer;
  display: inline-block;
}
.btn-ir-gordo:hover{
  opacity: 0.8;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

/* #nav a.router-link-exact-active {
  color: #42b983;
} */

.vue-notification-group{
  margin-top:120px !important;
}

.info-icon-container {
    position: relative;
    display: inline-block; /* Or block, depending on your layout needs */
}

.info-icon {
    cursor: pointer;
    /* Style your icon as needed */
}

.info-icon-container-popup {
    display: none;
    font-size: 14px;
    position: absolute;
    left: -20px; /* Adjust as necessary */
    bottom: 100%; /* Adjust popup position */
    width: 250px; /* Adjust width as necessary */
    background-color: white;
    border-radius: 4px;
    color: white;
    border: 1px solid #ddd; /* Optional */
    padding: 10px;
    z-index: 100;
    /* Add more styling as needed (e.g., shadows, rounded corners) */
}
.info-icon-container-popup::before {
    content: "";
    position: absolute;
   
    top: 100%; /* Position the arrow directly at the bottom of the popup */
    left: 30px; /* Center the arrow */
    margin-left: -5px; /* Half the width of the arrow to properly center it */
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent; /* Arrow color */
    /* Adjust the color to match the popup border or fill */
}

.info-icon-container:hover .info-icon-container-popup {
    display: block; /* Show the popup on hover */
}

/* Error Loading Styles */
.error-load-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8fafc;
  padding: 20px;
}

.error-card {
  background: white;
  padding: 40px;
  border-radius: 24px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  max-width: 400px;
  width: 100%;
  text-align: center;
  animation: slideUp 0.5s ease-out;
}

.error-icon-bg {
  width: 80px;
  height: 80px;
  background-color: #fef2f2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.error-card h2 {
  color: #1e293b;
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 12px;
}

.error-card p {
  color: #64748b;
  line-height: 1.6;
  margin-bottom: 32px;
}

.btn-retry {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 14px 24px;
  border: none;
  border-radius: 12px;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.btn-retry:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  filter: brightness(1.1);
}

.btn-retry:active {
  transform: translateY(0);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>